import localStorageKey from "../enumerations/localStorageKey";

export const removePromoteCode = () => {
  window.localStorage.removeItem(localStorageKey.PROMOTE_CODE);
};
